export default "__VITE_ASSET__CHuvdhUV__"